import { useContext, useEffect, useState } from "react";
import DataTable from "../../../controls/table/DataTable";
import EmptyPage from "../../../pages/EmptyPage";
import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MoveSitePage from "./site/MoveSitePage";
import AddIcon from "../../../../assets/img/add.png";
import EditIcon from "../../../../assets/img/Edit.png";
import DeleteIcon from "../../../../assets/img/Delete.png";
import CloneSitePage from "./site/CloneSitePage";
import { Button, Modal } from "react-bootstrap";
import { ArrowsMove } from "react-bootstrap-icons";

const ProjectSitesPage = () => {
  let [admin, setAdmin] = useState(false);
  let [superAdmin, setSuperAdmin] = useState(false);
  let [moderator, setModerator] = useState(false);


  const [tableData, setTableData] = useState([]);
  const [renderTable, setRenderTable] = useState(false);
  const [renderEmptyPage, setRenderEmptyPage] = useState(false);
  const [moveModalCanOpen, setMoveModalCanOpen] = useState(false);
  const [siteContent, setSiteContent] = useState([]);
  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [canRender, setCanRender] = useState(false);
  const navigate = useNavigate();
  let folderPath = useParams();
  let [folderName, setFolderName] = useState("");
  let location = useLocation();

  const {
    setLoadingState,
    setCanRedirectToLogin,
    userData,
    setAlert,
    virtualFolderData,
  } = useContext(ContextComponent);
  let [projectid, setProjectid] = useState(null);
  let [allSites, setAllSites] = useState([]);
  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  let [moveIconClass, setMoveIconClass] = useState(DISABLED_ICON);
  let [siteIdForEdit, setSiteIdForEdit] = useState("");
  let [cloneModalCanOpen, setCloneModalCanOpen] = useState(false);
  let [selectedItemCount, setSelectedItemCount] = useState(0);
  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "name",
    "description",
    "sme",
    "classicview",
    "survey",
    "quiz",
    "updatedView"
  ]);

  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
      center: true,
    },
    name: {
      type: "link",
      search: true,
      sort: false,
      title: "Name",
      handleLink: (obj) => {
        let isQuiz = obj.isQuiz || false;
        let isUpdatedView = obj?.isUpdatedView || false;
        Utils.setQuizSurveyMapValue(obj?.id, isQuiz);
        Utils.setUpdatedViewMapValue(obj?.id, isUpdatedView);
        navigate(
          Utils.APP_URLS.PROJECT_SITE_PAGE.replace(
            ":projectid",
            obj.projectId,
          ).replace(":siteid", obj.id),
        );
      },
    },
    description: {
      type: "text",
      search: true,
      sort: false,
      title: "Description",
    },
    sme: {
      type: "text",
      search: true,
      sort: false,
      title: "SME",
    },
    classicview: {
      type: "boolean",
      search: false,
      sort: false,
      title: "New Interface",
    },
    survey: {
      type: "boolean",
      search: false,
      sort: false,
      title: "Assessment/Quiz",
      key: "quiz",
    },
    quiz: {
      type: "clipboard",
      title: "Share",
    },
    updatedView: {
      type: "hidden",
      title: "updatedView",
    },
  });

  useEffect(() => {
    setAdmin(!!userData?.admin);
    setSuperAdmin(!!userData?.superAdmin);
    setModerator(userData?.roles?.includes("ROLE_MODERATOR") || false);
  }, [admin, superAdmin, moderator, userData]);

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");

      setSiteIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);

      setSiteIdForEdit("");
    }
    if (tableSelectedItems.length >= 1) {
      setMoveIconClass("");
    } else {
      setMoveIconClass(DISABLED_ICON);
    }
  }, [tableSelectedItems]);

  const getPath = (currentPath) => {
    const rootPaths = [
      "/",
      "/internal",
      "/internal/",
      "/internal/sites",
      "/internal/project",
      "/internal/project/",
      "/internal/project/Root",
    ];

    if (rootPaths.includes(currentPath)) {
      const rootNode = virtualFolderData.find((node) => node.parentId === null);
      if (rootNode) {
        setFolderName(rootNode.name);
        setProjectid(rootNode.id);
        return rootNode.path;
      } else {
        setFolderName("Root");
        return "/Root";
      }
    }
  };

  const findFolderNameById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node.name;
      }
      if (node.children && node.children.length > 0) {
        const foundName = findFolderNameById(node.children, id);
        if (foundName) {
          return foundName;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    if (virtualFolderData.length > 0 && folderPath["*"]) {
      const name = findFolderNameById(virtualFolderData, folderPath["*"]);
      if (name) {
        setFolderName(name);
      } else {
        setFolderName("Root");
      }
    }
    setProjectid(folderPath["*"]);
    if (virtualFolderData.length > 0) {
      const currentPath = location.pathname;
      getPath(currentPath);
    }
  }, [virtualFolderData, folderPath]);

  const updateTableData = (data) => {
    setAllSites(data);
    let siteInfo = data;
    let sitesArray = [];
    if (!Utils.isObjectEmpty(siteInfo)) {
      sitesArray = siteInfo.map((siteData, index) => {
        let siteTableObj = [];
        let siteTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            siteTableData.push(false);
          } else if (col === "classicview") {
            let valueToBePush = siteInfo?.[index]?.["classicview"] || false;
            siteTableData.push(valueToBePush);
          } else {
            siteTableData.push(siteInfo[index][col]);
          }
        });
        siteTableObj = siteTableData;
        return siteTableObj;
      });

      setTableData(sitesArray);
      setSiteContent(siteInfo);
      setCanRender(true);
    }
  };

  const success = (res) => {
    let data = res?.data || [];
    data = res?.data.sort((itemA, itemB) => {
      return itemA.name.localeCompare(itemB.name);
    });
    if (data.length > 0) {
      updateTableData(data);
      setRenderTable(true);
      setRenderEmptyPage(false);
    } else {
      setRenderEmptyPage(true);
      setRenderTable(false);
      setCanRender(true);
    }
    setLoadingState({ applyMask: false });
    setTableSelectedItems([]);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadProjectSites = () => {
    projectid === "root"
      ? Utils.getRootLevelSites().then(success, fail)
      : Utils.getProjectSites(projectid).then(success, fail);
  };

  useEffect(() => {
    if (projectid) {
      setLoadingState({ applyMask: true, text: "Loading Project sites..." });
      loadProjectSites();
    }
  }, [projectid]);

  const openMoveModal = (e) => {
    e.preventDefault();
    setMoveModalCanOpen(true);
  };

  const openCloneModal = (e) => {
    e.preventDefault();
    setCloneModalCanOpen(true);
  };

  const navgiatToAddPage = (e) => {
    e.preventDefault();
    navigate(Utils.APP_URLS.ADD_SITE_PAGE);
  };

  const navgiatToEditPage = (e) => {
    e.preventDefault();
    allSites.forEach((site) => {
      if (site.id === siteIdForEdit && site.projectId === projectid) {
        navigate(
          Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE.replace(
            ":projectid",
            projectid
          ).replace(":siteid", siteIdForEdit)
        );
      } else if (site.id === siteIdForEdit && site.projectId === "") {
        navigate(
          Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE.replace(
            ":projectid",
            "root"
          ).replace(":siteid", siteIdForEdit)
        );
      }
    });
  };

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Site(s) deleted successfully",
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
    setAlert({
      show: true,
      message: err?.data?.message
        ? err.data.message
        : "Site(s) deletion failed",
      type: "danger",
    });
    err?.message?.length && console.log(err);
  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    let tempTableData = tableData.filter((d) => {
      return tableSelectedItems.indexOf(d[0]) === -1;
    });
    setTableData(tempTableData);

    if (tempTableData.length === 0) {
      setRenderEmptyPage(true);
      setRenderTable(false);
    }

    Utils.deleteSites(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        {folderName}
        <div className="d-none1 w-50 indi-body-actions">
          {(admin || superAdmin) && (
            <div
              className={`indi-body-action ${moveIconClass}`}
              role="button"
              onClick={openMoveModal}
            >
              <span className="indi-move-icon">
                <ArrowsMove />
              </span>
              Move
            </div>
          )}

          {(admin || superAdmin || moderator) && (
            <div
              className={`indi-body-action ${editIconClass}`}
              role="button"
              onClick={openCloneModal}
            >
              <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
              Clone
            </div>
          )}

          {((false && admin) || (false && superAdmin)) && (
            <div
              className="indi-body-action"
              role="button"
              onClick={navgiatToAddPage}
            >
              <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
              Add
            </div>
          )}
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={navgiatToEditPage}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>

          <div
            className={`indi-body-action ${moveIconClass}`}
            role="button"
            onClick={handleShow}
          >
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>

      {canRender && (
        <>
          {renderTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
              }}
            />
          )}
          {renderEmptyPage && (
            <EmptyPage props={{ emptyMessage: "No projects data found." }} />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete selected {selectedItemCount} item
          {selectedItemCount > 1 ? "s" : ""}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {cloneModalCanOpen && (
        <CloneSitePage
          props={{
            cloneModalCanOpen,
            setCloneModalCanOpen,
            tableData,
            setTableData,
            tableSelectedItems,
            setTableSelectedItems,
            projectid,
            loadProjectSites,
            type: "clone",
            tableColumns,
          }}
        />
      )}

      {moveModalCanOpen && (
        <MoveSitePage
          props={{
            moveModalCanOpen,
            setMoveModalCanOpen,
            tableData,
            setTableData,
            siteContent,
            setSiteContent,
            currentFolderId: projectid,
            loadProjectSites,
            tableSelectedItems,
            setTableSelectedItems,
            type: "move",
          }}
        />
      )}
    </div>
  );
};

export default ProjectSitesPage;
